import { AlertTitle, Collapse } from "@mui/material"
import { ReactElement } from "react"

import AppAlert from "../../../dataDisplay/alerts/appAlert"

interface IArrayFormGlobalErrorDisplayProps {
    formErrors: unknown
}

/** A global form level error display component. It informs the user of the
 * number of errors with their input. Form errors is the output of errors
 * from react-hook-form, indexed using the formKey. Note, the type of formErrors
 * is not relevant to the component, so it is typed as unknown.
 */
const ArrayFormGlobalErrorDisplay = ({
    formErrors,
}: IArrayFormGlobalErrorDisplayProps): ReactElement => {
    const errorsTypeSafe = Array.isArray(formErrors) ? (formErrors as []) : []
    const devicesWithError = errorsTypeSafe.filter((error) => !!error).length
    return (
        <Collapse in={devicesWithError !== undefined && devicesWithError > 0}>
            <AppAlert severity="warning">
                <AlertTitle>
                    {`${devicesWithError} of the devices you have defined above ${
                        devicesWithError > 1 ? "have" : "has"
                    } input errors. Scroll up for more information`}
                </AlertTitle>
            </AppAlert>
        </Collapse>
    )
}

export default ArrayFormGlobalErrorDisplay
